import React from 'react';
import moment from 'moment';
import classnames from 'classnames';

import './index.scss';
const roleDisplay = {
  'STAFF':'BUSINESS STAFF',
  'MARKETING':'MARKETING STAFF'
};
class StaffList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle:false,
      modalopen:false,
      showsucess:false
    };
  }

  getLastLoginTime = (staff,user) =>{
    if(staff.login_time){
      return staff.login_time;
    }else if(staff.id === user.userid){
      return new Date();
    }
    return false;
  }
  sortStaffList=(staffs)=>{
    const priorityList = staffs.map(staff=>{
      staff.priority= staff.role === 'ADMIN'? 0 : (staff.role === 'STAFF'? 1 : 2);
       return staff;
    });
    
   return priorityList.sort((a,b)=> a.priority - b.priority);
  }

  render() {
    const { staffs, removeStaff,staffManagement,user } = this.props;
    return (
      <div className="stafflist">
          <table className="table">
              <tr className="table_header">
                  <td>Account</td>
                  <td>Account Type</td>
                  <td>Email</td>
                  <td>Phone Number</td>
                  <td>Last active</td>
                  <td></td>
              </tr>
              {staffs && this.sortStaffList(staffs).map(staff=>{   
                return (<tr className="table_data">
                  <td className="table_data_name">{staff.firstName} {staff.lastName}</td>
                  <td className="table_data_role">{roleDisplay[staff.role] || staff.role}</td>
                  <td className="table_data_email">{staff.email}</td>
                  <td className="table_data_phone">{staff.phone|| '--'}</td>
                  <td className="table_data_active">
                      {(this.getLastLoginTime(staff,user))?(moment(this.getLastLoginTime(staff,user)).fromNow()):(<div className="tag">Invitation pending</div>)}
                  </td>

                  <td>{(staff.role!=='ADMIN') && (<div className="remove" onClick={()=>removeStaff(staff)} disabled={staffManagement.deleteuser}>Remove</div>)}</td>
              </tr>)
              })}
          </table>
      </div>
    );
  }
}
export default StaffList;
